<template>
  <header class="nav" role="banner">
    <div class="wrap row">
      <a class="brand" href="#top">
        <b>&capital</b>
      </a>
      <nav>
        <a
          v-for="link in navLinks"
          :key="link.href"
          class="link"
          :href="link.href"
        >
          {{ link.label }}
        </a>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue';

const navLinks = ref([
  { href: '#what', label: 'What we do' },
  { href: '#how', label: 'How we work' },
  { href: '#focus', label: 'Focus' },
  { href: '#globe-window', label: 'Experience' },
  { href: '#contact', label: 'Contact' }
]);
</script>

<style scoped>
/* Navigation styles are inherited from global styles.css */
/* Component-specific overrides can go here if needed */
</style>
